export default function($form,callback) {
  var $params=$form.getExtForm();
  if (!$form.isValid(true)) {
    return false;
  }
  var btnName = $params.action;
  $params.setBtnLoading(true, btnName);
  function save(data,err){
    $params.setBtnLoading(false, btnName);
    if(!err) {
      if(callback)callback(data);
      PF.message($lang("表单数据保存成功")+"!");
    }
  }

  $params.startProcess(save);

}



// WEBPACK FOOTER //
// ./src/common/components/extend/form/src/config/flow-save.js